import React from "react";
import jwt_decode from 'jwt-decode';
import DataGrid, {
  Column,
  Button,
  FilterRow,
  HeaderFilter, Paging, Pager
} from "devextreme-react/data-grid";

import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { ToastContainer, toast } from 'react-toastify';
import "devextreme/data/odata/store";
import { createStore } from "devextreme-aspnet-data-nojquery";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import { config } from "../../constants";
import { Form, Row, Modal, Button as ButtonBootstrap } from "react-bootstrap";
import ConfirmationModal from "../ui/ConfirmationModal";
// Images
import plusimg from "../../images/common/plus.png";
import eyeimg from "../../images/report/eye.png";
import gearimg from "../../images/report/gear.png";
import downloadimg from "../../images/report/download.png";
import shareimg from "../../images/report/share.png";

import budgetAnalysisIcon from "../../images/report/budget-analysis-icon.svg";
import onePagerIcon from "../../images/report/one-pager-icon.svg";
import detailedExportIcon from "../../images/report/detailed-export-icon.svg";
import Maximize from "../ui/Maximize";
import Minimize from "../ui/Minimize";
import ReportModal from "./ReportModal";
import SaveReportModal from "./SaveReportModal"; 

import { LoadPanel } from 'devextreme-react/load-panel';
import apiClient from '../../utils/apiClient';
import { handleErrorResponse } from '../../utils/apiClient';

const url = config.url.URL;
const reportLoadUrl = `${url}/ReportMicroservice`;
const sharedReportLoadUrl = `${url}/SharedInReportMicroservice`;

const savedReportDataSource = createStore({
  key: "reportId",
  loadUrl: reportLoadUrl,
  insertUrl: `${url}/InsertOrder`,
  updateUrl: `${url}/UpdateOrder`,
  onBeforeSend: (method, ajaxOptions) => {
    ajaxOptions.headers = {
      'accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem('token'),
      'content-type': 'application/json',      
    }
  },
  onAjaxError: (e) => {
    const { xhr, error } = e;
    handleErrorResponse(error || { message: 'Unknown error occurred.', response: xhr });
  }
});

const sharedReportDataSource = createStore({
  key: "reportId",
  loadUrl: sharedReportLoadUrl,
  insertUrl: `${url}/InsertOrder`,
  updateUrl: `${url}/UpdateOrder`,
  onBeforeSend: (method, ajaxOptions) => {
    ajaxOptions.headers = {
      'accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem('token'),
      'content-type': 'application/json',
    }
  },
  onAjaxError: (e) => {
    const { xhr, error } = e;
    handleErrorResponse(error || { message: 'Unknown error occurred.', response: xhr });
  }
});



export default class ReportList extends React.Component {
  constructor(props) {
    super(props);

    this.applyFilterTypes = [
      {
        key: "auto",
        name: "Immediately",
      },
      {
        key: "onClick",
        name: "On Button Click",
      },
    ];

    const currentYear = new Date().getFullYear();
    // Generate years from 2018 to the current year
    const years = Array.from(
      { length: currentYear - 2018  +2},
      (_, index) => currentYear - index + 1
    );

    this.state = {
      showFilterRow: false,
      showHeaderFilter: false,
      currentFilter: this.applyFilterTypes[0].key,
      showColumnLines: false,
      showRowLines: true,
      showBorders: true,
      rowAlternationEnabled: true,
      showDetailedExportModal: false,
      currentTab: "1",
      fullscreen: false,
      loadPanelVisible: false,

      can_save_reports: false,
      can_share_reports: false,
      can_export_to_excel: false,
      can_create_reports: false,
      can_access_report_OnePage: false,
      yearsToExport: years,
    };

    this.handleTabChange = this.handleTabChange.bind(this);
    this.dataGridRef = React.createRef();
  }

  fullscreenHandler = () => {
    this.setState(prevState => ({ fullscreen: !prevState.fullscreen }));
  }

  handleTabChange(evt, tabValue) {
    this.setState({ currentTab: tabValue });
  }

  renderDate(date) {
    return new Date(date.value).toLocaleDateString("en-US");
  }

  openDetailedExportModal = () => {
    this.setState({ showDetailedExportModal: true });
  }

  openShareModal = (e) => {
    this.refs.saveRepModal.openShareModal(e);
  }

  openModal = (e) => {
    this.refs.repModal.openModal(e);
  }

  ViewReport = (e) => {
    //console.log(e.row.data.reportId);
    this.props.history.push({ pathname: "/report/reportView", state: { 'reportId': e.row.data.reportId, 'download': false } });
  }

  DownloadReport = (e) => {
    this.props.history.push({ pathname: "/report/reportView", state: { 'reportId': e.row.data.reportId, 'download': true } });
  }

  DownloadOnePagerReport = (e) => {
    this.setState({ loadPanelVisible: true })

    apiClient.get(`${url}/OnePagerReportMicroservice`, {
      responseType: 'blob', 
      headers: {
        'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }
    })
      .then((response) => {
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        let now = new Date();
        let date = now.getFullYear() + 
                   ('0' + (now.getMonth() + 1)).slice(-2) + 
                   ('0' + now.getDate()).slice(-2) + '_' + 
                   ('0' + now.getHours()).slice(-2) + 'h' + 
                   ('0' + now.getMinutes()).slice(-2);
        
        link.setAttribute('download', `OnePager_Export_${date}.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        toast.success('One Pager file generated!');
        this.setState({ loadPanelVisible: false });
      })
      .catch((error) => {
       // toast.error('An error occurred while generating the file.');
        this.setState({ loadPanelVisible: false });
      });

  }

  DownloadDetailedExport = () => {
    this.setState({ loadPanelVisible: true })

    const currency = (
                        (this.refs.rdBudget.checked ? "Budget" : "") +
                        (this.refs.rdR1.checked ? "R1" : "") +
                        (this.refs.rdR2.checked ? "R2" : "")
                    )

    const selectedYears = this.state.yearsToExport.filter((year, index) => {
      const ref = this.refs[`chk${index + 1}`];
      return ref && ref.checked;
    });
    const year = selectedYears.join(",");
    apiClient.get(`${url}/DetailedExportMicroservice?selectedCurrency=${currency}&selectedYears=${year}`, {
      responseType: 'blob', // Important to handle binary data like files
      customErrorMessage: 'Error while generating the export file.'
    })
      .then((response) => {
        const blob = response.data;
        // Create a URL from the blob
        const url = window.URL.createObjectURL(new Blob([blob], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }));
        const link = document.createElement('a');
        link.href = url;

        // Generate a date string for the file name
        let now = new Date();
        let date = now.getFullYear() + 
                   ('0' + (now.getMonth() + 1)).slice(-2) + 
                   ('0' + now.getDate()).slice(-2) + '_' + 
                   ('0' + now.getHours()).slice(-2) + 
                   ('0' + now.getMinutes()).slice(-2);
        link.setAttribute('download', `Detailed_Export_${date}.xlsx`);

        // Append the link to the DOM and trigger the download
        document.body.appendChild(link);
        link.click();

        // Clean up after the download
        link.parentNode.removeChild(link);

        toast.success('Detailed Export file generated!');

        // Update the component state
        this.setState({ showDetailedExportModal: false });
        this.setState({ loadPanelVisible: false });
      })
      .catch((error) => {
        // Handle any errors that Axios catches
        this.setState({ loadPanelVisible: false }); // Hide the loader in case of error
      });
  }


  handleClose = () => {
    this.setState({ showConfirmationModal: true });
  }

  doubleCloseModals = () => {
    this.setState({
      showConfirmationModal: false,
      showDetailedExportModal: false
    });
  }

  closeConfirmationModal = () => {
    this.setState({ showConfirmationModal: false });
  }

  SelectAllYears = () => {
    let stat = this.refs.chkAll.checked;
    const { yearsToExport } = this.state;
    yearsToExport.forEach((_, index) => {
      let refName = `chk${index + 1}`;
      if (this.refs[refName]) {
        this.refs[refName].checked = stat;
      }
    });
  };
  

  SelectAnyYears = () => {
    this.refs.chkAll.checked = false;
  }

  refreshReports = () => {
    if (this.dataGridRef && this.dataGridRef.current) {
      this.dataGridRef.current.instance.refresh();
    }
  };
  

  componentDidMount() {

    const decoded = jwt_decode(localStorage.getItem('token'));
    this.setState({
      can_save_reports: decoded.can_save_reports === "true",
      can_share_reports: decoded.can_share_reports === "true",
      can_export_to_excel: decoded.can_export_to_excel === "true",
      can_create_reports: decoded.can_create_reports === "true",
      can_access_report_OnePage:  decoded.can_access_report_OnePage === "true"
    });
  };

  render() {
    // Divide the years into exactly 2 groups, accounting for "ALL" in the first group
    const { yearsToExport } = this.state;
    const chunkedYears = [];
    const midIndex = Math.ceil((yearsToExport.length + 1) / 2);
    chunkedYears.push(yearsToExport.slice(0, midIndex - 1)); 
    chunkedYears.push(yearsToExport.slice(midIndex - 1)); 

    const savedReports = (
      <div className="div-scroll padding-margin-20">
        <DataGrid
          ref={this.dataGridRef}
          className="ReportGrid"
          dataSource={savedReportDataSource}
          keyExpr="reportId"
          showBorders={false}
          showColumnLines={false}
          showRowLines={false}
          rowAlternationEnabled={this.state.rowAlternationEnabled}
        >
          <Pager
            visible={true}
            displayMode={"full"}
            showPageSizeSelector={true}
            showInfo={true}
            showNavigationButtons={true}
            allowedPageSizes={[5, 10, 20, 30, 40, 50]}
          />

          <Paging defaultPageSize={30} />
          <FilterRow
            visible={this.state.showFilterRow}
            applyFilter={this.state.currentFilter}
          />
          <HeaderFilter visible={this.state.showHeaderFilter} placeholder={true} />
          <Column dataField="name" caption="Report Name" />
          <Column dataField="reportType" caption="Type" />
          <Column
            dataField="createdDate"
            caption="Created Date"
            customizeText={this.renderDate}
          />
          <Column dataField="isSharedReport" caption="Shared" />
          <Column fixed={true} fixedPosition="right" type="buttons">
            <Button hint="View" title="View" className="img-grid" icon={eyeimg} onClick={this.ViewReport} />
            <Button hint="Settings" className="img-grid" icon={gearimg} onClick={this.openModal} />
            <Button hint="Download" visible={this.state.can_export_to_excel}
              className="img-grid" icon={downloadimg} onClick={this.DownloadReport} />
            <Button hint="Share Report" visible={this.state.can_share_reports}
              className="img-grid" icon={shareimg} onClick={this.openShareModal} />
          </Column>
        </DataGrid>
      </div>
    );

    const sharedReport = (
      <div className="div-scroll padding-margin-20">
        <DataGrid
          className="ReportGrid"
          dataSource={sharedReportDataSource}
          keyExpr="ID"
          showBorders={false}
          showColumnLines={false}
          showRowLines={false}
          rowAlternationEnabled={this.state.rowAlternationEnabled}
        >

          <Pager
            visible={true}
            displayMode={"full"}
            showPageSizeSelector={true}
            showInfo={true}
            showNavigationButtons={true}
            allowedPageSizes={[5, 10, 20, 30, 40, 50]}
          />
          <Paging defaultPageSize={30} />
          <FilterRow
            visible={this.state.showFilterRow}
            applyFilter={this.state.currentFilter}
          />
          <HeaderFilter visible={this.state.showHeaderFilter} />
          <Column dataField="name" caption="Report Name" />
          <Column dataField="reportType" caption="Type" />
          <Column
            dataField="createdDate"
            caption="Created Date"
            customizeText={this.renderDate}
          />
          <Column dataField="userName" caption="Shared" />
          <Column fixed={true} fixedPosition="right" type="buttons">
            <Button className="img-grid" icon={eyeimg} onClick={this.ViewReport} />
            <Button className="img-grid" icon={downloadimg} onClick={this.DownloadReport} />
          </Column>
        </DataGrid>
      </div>
    );

    return (
      <div className="div-body-section-details">
        <div className="div-body-section-details-header">
          <div className="div-section-title">
            <span>{"Reports"}</span>
          </div>
          <div className="div-section-actions push">
            <button className="btn-section-header" onClick={this.openDetailedExportModal}>
              <img className="img-section-header" src={plusimg} alt="Detailed Export" />
              <label>Detailed Export</label>
            </button>
            {this.state.can_access_report_OnePage && (
            <button className="btn-section-header" onClick={this.DownloadOnePagerReport}>
              <img className="img-section-header" src={plusimg} alt="One Pager Report" />
              <label>One Pager Report</label>
            </button>
            )}
            <button className="btn-section-header" onClick={this.openModal}>
              <img className="img-section-header" src={plusimg} alt="New Report" />
              <label>New Report</label>
            </button>
          </div>
        </div>


        <div className="padding-15">
          <label className="font-color">New</label>
        </div>

        <div className="boxes">
          <button onClick={this.openModal} className="box-shadow">
            <img width="80" height="120" src={budgetAnalysisIcon} alt="Budget Analysis<"></img><br /><p className="dim-gray-color">Budget Analysis</p>
          </button>
          {this.state.can_access_report_OnePage && (
          <button onClick={this.DownloadOnePagerReport} className="box-shadow">
            <img width="90" height="120" src={onePagerIcon} alt="One Pager Report"></img><br /><p className="dim-gray-color">One Pager Report</p>
          </button>
          )}
          <button onClick={this.openDetailedExportModal} className="box-shadow">
            <img width="80" height="120" src={detailedExportIcon} alt="Detailed Export"></img><br /><p className="dim-gray-color">Detailed Export</p>
          </button>
        </div><br />

        <div className="div-body-section-details-body">

          <LoadPanel
            shadingColor="rgba(0,0,0,0.4)"
            visible={this.state.loadPanelVisible}
            showIndicator={true}
            shading={true}
            showPane={true}
            hideOnOutsideClick={false}
          />

          <Box sx={{ width: "100%", typography: "body1" }} className="titles" >

            {
              this.state.can_create_reports && (this.state.can_save_reports || this.state.can_share_reports)
              && <TabContext value={this.state.currentTab}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <TabList aria-label="tabs" onChange={this.handleTabChange}>
                  {this.state.can_save_reports && (
                    <Tab className="font-capital" label="Saved" value="1" />
                  )}
                    <Tab
                      className="font-capital"
                      label="Shared with me"
                      value="2"
                    />
                  </TabList>
                </Box>
                <TabPanel value="1" className="font-size-12 padding-left">
                  {savedReports}
                </TabPanel>

                <TabPanel value="2" className="font-size-12">
                  {sharedReport}
                </TabPanel>
              </TabContext>
            }
          </Box>
        </div>

        <ReportModal ref="repModal"></ReportModal>

        <SaveReportModal ref="saveRepModal" onSave={this.refreshReports}></SaveReportModal>

        <Modal show={this.state.showDetailedExportModal} onHide={this.handleClose} size="sm" fullscreen={this.state.fullscreen}>
          <Modal.Header closeButton>
            <Modal.Title size="h6" >Detailed Export Perimeter</Modal.Title>
            <button
              type="button"
              class="btn btn-primary report-btn"
              onClick={this.fullscreenHandler}
            >
              {this.state.fullscreen ? <Maximize /> : <Minimize />}
            </button>
          </Modal.Header>
          <Modal.Body>
            <div className="margin-10">

              <Row>
                <Form.Group className="mb-3 col-md-4" controlId="Name">
                  <Form.Check
                    type="radio"
                    name="Corporate"
                    label="Budget"
                    ref="rdBudget"
                    defaultChecked
                  />
                  <Form.Check type="radio" name="Corporate" label="R1" ref="rdR1" />
                  <Form.Check type="radio" name="Corporate" label="R2" ref="rdR2" />
                </Form.Group>
                {chunkedYears.map((yearsChunk, columnIndex) => (
                  <Form.Group
                    key={columnIndex}
                    className="mb-3 col-md-4"
                  >
                    {columnIndex === 0 && (
                      <Form.Check
                        id="chkAll"
                        type="checkbox"
                        label="ALL"
                        ref="chkAll"
                        onClick={this.SelectAllYears}
                      />
                    )}
                    {yearsChunk.map((year, index) => {
                      const globalIndex = (columnIndex === 0 ? index : chunkedYears[0].length + index) + 1;
                      return (
                        <Form.Check
                          id={`chk${globalIndex}`}
                          key={index}
                          type="checkbox"
                          label={year.toString()}
                          ref={`chk${globalIndex}`}
                          onClick={this.SelectAnyYears}
                        />
                      );
                    })}
                  </Form.Group>
                ))}
              </Row>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <ButtonBootstrap variant="secondary" className='btnSecondary' onClick={this.handleClose}>
              Cancel
            </ButtonBootstrap>
            <ButtonBootstrap variant="primary" className='btnPrimary' onClick={this.DownloadDetailedExport}>
              Generate Report
            </ButtonBootstrap>
          </Modal.Footer>
        </Modal>
        <ConfirmationModal show={this.state.showConfirmationModal} hide={this.closeConfirmationModal} doubleCloseModals={this.doubleCloseModals} msg="Are you sure you want to leave this page ?" />

        <ToastContainer position="bottom-right" />
      </div>
    );
  }
}